import { render } from "./EmployeePendingPrs.vue?vue&type=template&id=104ec88d"
import script from "./EmployeePendingPrs.vue?vue&type=script&lang=js"
export * from "./EmployeePendingPrs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__